import {
  isMainOpenFinWindow,
  isOpenFinRuntime
} from '../containers/OpenFin/helpers'

/* redux-state-sync only relays future actions, so a popout opened after a user is
   selected never learns it. localStorage seeds it on boot (same as helpers/theme). */
const SELECTED_USER_STORAGE_KEY = 'selectedUser'

export const storeSelectedUser = (selectedUser: number): void => {
  try {
    if (selectedUser) {
      localStorage.setItem(SELECTED_USER_STORAGE_KEY, String(selectedUser))
    } else {
      localStorage.removeItem(SELECTED_USER_STORAGE_KEY)
    }
  } catch (err) {
    console.warn('Failed to store selected user in localStorage', err)
  }
}

export const readStoredSelectedUser = (): number => {
  try {
    const stored = Number(localStorage.getItem(SELECTED_USER_STORAGE_KEY))
    return Number.isFinite(stored) ? stored : 0
  } catch {
    return 0
  }
}

/*  Only OpenFin popouts seed from localStorage; the main window (and web) start
    at 0 so a new session never inherits the prior one's selection. */
export const getInitialSelectedUser = (): number =>
  isOpenFinRuntime() && !isMainOpenFinWindow() ? readStoredSelectedUser() : 0

export const clearStoredSelectedUser = (): void => {
  try {
    localStorage.removeItem(SELECTED_USER_STORAGE_KEY)
  } catch (err) {
    console.warn('Failed to clear selected user from localStorage', err)
  }
}
